module.exports = __webpack_public_path__ + "img/SprayPainting2.ea9e0b21.jpg";